import { HeaderAndTableCellDraft, SortAttributes } from '@markant-platform/shared/table/model';

export const HEADER_AND_TABLE_CELL: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'firstName',
    headerCellTranslationKey: 'dashboardOverview.groupAssignment.detail.memberTable.firstName',
    tableCellContentKey: 'firstname',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'lastName',
    headerCellTranslationKey: 'dashboardOverview.groupAssignment.detail.memberTable.lastName',
    tableCellContentKey: 'lastname',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'email',
    headerCellTranslationKey: 'dashboardOverview.groupAssignment.detail.memberTable.email',
    tableCellContentKey: 'email',
    tableCellContentType: 'STRING',
  },
];

export const DEFAULT_SORT: SortAttributes = { sortField: 'firstName', sortOrder: 'asc' };
